export enum SiteContextModeEnum {
  b2c = 'b2c',
  b2b = 'b2b',
}
